import { MINIAPP_PACKAGE_ID, subscriptionToolId } from '@/consts/configs';
import { publishSdkEvent } from './publishSdkEvent';

const openOfferScreen = (toolId?: string) => {
  publishSdkEvent({
    event: 'OpenOfferScreen',
    data: {
      toolId: toolId ?? subscriptionToolId,
      is_pro_touchpoint: true,
      touchpoint: 'preset-gen-generic',
      action: MINIAPP_PACKAGE_ID,
      source: MINIAPP_PACKAGE_ID,
      entryPoint: MINIAPP_PACKAGE_ID,
      action_source: MINIAPP_PACKAGE_ID,
      action_button: MINIAPP_PACKAGE_ID,
    },
  });
};

export { openOfferScreen };
